module.exports = __webpack_public_path__ + "img/btn-cart-date-active.18dd12fe.svg";